import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface ReloadIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const ReloadIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: ReloadIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <g clipPath="url(#clip0_1_5620)">
                <path
                    d="M20 13C20 17.4183 16.4183 21 12 21C7.5817 21 4 17.4183 4 13C4 8.58172 7.5817 5 12 5C13.5593 5 15.0143 5.44609 16.2446 6.21762"
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap="round"
                />
                <path
                    d="M14.7616 1.89795L16.5014 5.83917C16.7245 6.34441 16.4957 6.9348 15.9904 7.15784L12.0492 8.89768"
                    stroke={color}
                    strokeWidth={2}
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_5620">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ReloadIcon
